import { lazy } from 'react';

import { ErrorBoundary } from './error-boundary';
import { lazyRoute } from './lazy-route';

import type { RouteObject } from 'react-router-dom';

// /education -- index route: no path, so it stays outside the lazyRoute factory.
const EducationOverview = lazy(() => import('@/features/education/pages/EducationOverview'));
const educationOverview: RouteObject = {
  index: true,
  element: <EducationOverview />,
  errorElement: <ErrorBoundary />
};

// /education/video-management
const videoOverview = lazyRoute(
  'video-management',
  () => import('@/containers/EducationModuleContainers/VideoOverview')
);

// /education/video
const videoView = lazyRoute(
  'video/:id',
  () => import('@/containers/EducationModuleContainers/VideoView')
);

// /education/videos/:category
const videoList = lazyRoute(
  'videos/:category',
  () => import('@/features/education/pages/EducationVideoListPage')
);

// /education
export const educationRoutes: RouteObject = lazyRoute(
  '/education',
  () => import('@/modules/EducationModule'),
  { children: [educationOverview, videoOverview, videoView, videoList] }
);
